import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class CameraStreamConfigs extends SnModel {
  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }

  @Expose()
  public bandwidth: number;

  @Expose()
  public cameraId: string;

  @Expose()
  public loopDuration: number;

  @Expose()
  public path: string;

  @Expose()
  public record: boolean;
}

export class CameraStreamConfigsMap {
  [cameraId: string]: CameraStreamConfigs;
}
